// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  width: 100%;
}
@media (min-width: 640px) {
  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {
  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {
  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {
  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {
  .container {
    max-width: 1536px;
  }
}
.visible {
  visibility: visible;
}
.collapse {
  visibility: collapse;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.\\!m-0 {
  margin: 0px !important;
}
.m-2 {
  margin: 0.5rem;
}
.m-auto {
  margin: auto;
}
.\\!ml-0 {
  margin-left: 0px !important;
}
.\\!mt-\\[-15px\\] {
  margin-top: -15px !important;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-9 {
  margin-top: 2.25rem;
}
.line-clamp-1 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.\\!table {
  display: table !important;
}
.table {
  display: table;
}
.table-cell {
  display: table-cell;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.h-12 {
  height: 3rem;
}
.h-52 {
  height: 13rem;
}
.h-9 {
  height: 2.25rem;
}
.h-\\[120px\\] {
  height: 120px;
}
.min-h-screen {
  min-height: 100vh;
}
.w-12 {
  width: 3rem;
}
.w-64 {
  width: 16rem;
}
.w-80 {
  width: 20rem;
}
.w-9 {
  width: 2.25rem;
}
.w-\\[80\\%\\] {
  width: 80%;
}
.w-full {
  width: 100%;
}
.max-w-full {
  max-width: 100%;
}
.max-w-md {
  max-width: 28rem;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.grow {
  flex-grow: 1;
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.cursor-pointer {
  cursor: pointer;
}
.resize {
  resize: both;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.overflow-hidden {
  overflow: hidden;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text-ellipsis {
  text-overflow: ellipsis;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.border {
  border-width: 1px;
}
.bg-\\[\\#132743\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(19 39 67 / var(--tw-bg-opacity, 1));
}
.bg-blue-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(219 234 254 / var(--tw-bg-opacity, 1));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(243 244 246 / var(--tw-bg-opacity, 1));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(229 231 235 / var(--tw-bg-opacity, 1));
}
.bg-purple-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(126 34 206 / var(--tw-bg-opacity, 1));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-8 {
  padding: 2rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.text-center {
  text-align: center;
}
.text-start {
  text-align: start;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.capitalize {
  text-transform: capitalize;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.text-\\[\\#001843\\] {
  --tw-text-opacity: 1;
  color: rgb(0 24 67 / var(--tw-text-opacity, 1));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(107 114 128 / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(75 85 99 / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(55 65 81 / var(--tw-text-opacity, 1));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(239 68 68 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.no-underline {
  text-decoration-line: none;
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline {
  outline-style: solid;
}
.blur {
  --tw-blur: blur(8px);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.invert {
  --tw-invert: invert(100%);
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
/* Apply line-clamp-2 to all DataGrid cells */
.css-1n4ipc8-MuiDataGrid-root .MuiDataGrid-cell {
  /* color: red !important; */
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  /* from justify to start */
  text-align: start;
}

.page-break-avoid {
  break-inside: avoid;
  page-break-inside: avoid;
  -webkit-column-break-inside: avoid;
  display: block;
}
/* Hide sorting arrows globally */
.MuiDataGrid-sortIcon {
  display: none !important;
}

/* Fix header title alignment after removing arrows */
.MuiDataGrid-columnHeaderTitleContainer {
  flex-direction: row !important;
}

html {
  background-color: #eff3f4;
  zoom: 0.8;
}

/* Full-bleed get-started / control-plane shells — cancel global zoom so
   fixed inset:0 and 100% height actually cover the viewport (no gray gap). */
html.gs-no-zoom,
html.auth-no-zoom {
  zoom: 1;
}

/* Workspace setup: keep the 80% zoom, but paint the letterbox white. */
html.sn-canvas {
  background-color: #fff;
}

body {
  margin: 0;
  background-color: #eff3f4;
  min-height: 100%;
}

#root {
  min-height: 100%;
  background-color: #eff3f4;
}

/* Fix MUI Popover/Menu positioning with zoom: 0.8 */
/* When html is zoomed to 80%, fixed-position dropdowns need inverse scaling */
.MuiPopover-root,
.MuiMenu-root {
  zoom: 1.25; /* Inverse of 0.8: 1/0.8 = 1.25 */
}

/* Fix Joyride positioning/coverage with global html zoom: 0.8.
   Overlay AND floater must use the same inverse zoom, otherwise the
   spotlight tracks the target while the tooltip stays near the origin. */
.react-joyride__overlay,
.react-joyride__floater {
  zoom: 1.25;
  transform-origin: top left;
}

.react-joyride__tooltip,
.react-joyride__beacon {
  zoom: 1;
  transform-origin: top left;
}
/* .MuiBox-root.css-9h98sf {
  height: 115vh !important;
  width: 100% !important;
}

.MuiBox-root.css-9h98sf > * {
  width: auto !important;
} */

body {
  margin: 0;
  overflow-x: hidden;
  background-color: #fbfbfb;
  width: 100%;
  min-height: 100vh;
}

#root {
  min-height: 100vh;
  width: 100%;
  background-color: #fbfbfb;
}
body *::first-letter {
  text-transform: uppercase !important;
}

/* MUI Dialog: global ::first-letter + zoom on .MuiModal-root can hide or distort list text */
.MuiDialog-root *::first-letter {
  text-transform: none !important;
}

/* Import wizard dialog must sit above DataGrid loading skeleton overlay */
.import-risks-wizard-dialog.MuiDialog-root {
  z-index: 10000 !important;
  zoom: 1 !important;
}

.import-risks-wizard-dialog .MuiDialog-container,
.import-risks-wizard-dialog .MuiDialog-paper {
  pointer-events: auto !important;
}

/* Keep grid loading overlay inside the grid stacking context so it cannot paint over modals */
.MuiDataGrid-root .MuiDataGrid-overlayWrapper {
  z-index: 1 !important;
}
h3,
h1,
h2,
h4,
h5,
h6 {
  /* text-transform: capitalize !important; */
}
.title {
  /* text-transform: capitalize !important; */
}

code {
  font-family:
    source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

.rs-input-group {
  height: 100% !important;
  border: 0.8px solid rgba(0, 0, 0, 0.2) !important;
}
.rs-input-group-lg.rs-input-group > .rs-input {
  height: auto !important;
}
.rs-input-group-lg.rs-input-group > .rs-input-group-addon {
  height: auto !important;
}

.scheduler_default_main {
  width: 100%;
}
.scheduler_default_corner {
  z-index: -999999;
}

/* Si vous souhaitez également cacher la barre de défilement verticale */
::-webkit-scrollbar {
  display: none; /* Cache la barre de défilement */
}

.breadcrumbs .title {
  margin-left: 0px;
}
.breadcrumbs div {
  margin-left: 0px;
}

.breadcrumbs button {
  padding: 8px 48px;
}
.App {
  background-color: #fbfbfb;
}
.MuiSvgIcon-fontSizeSmall {
  color: rgba(255, 255, 255, 0.5);
}

a:hover,
*:focus {
  text-decoration: none;
  outline: none;
}
.dash-tabs button {
  color: #5b6b87;
  font-size: 16.875px;
  letter-spacing: 0;
}

/* Fix for MUI Tabs indicator misalignment when global zoom: 0.8 is applied */
.MuiTabs-indicator {
  zoom: 1.25; /* Inverse of 0.8: 1/0.8 = 1.25 */
}

.pdf-page-group {
  page-break-inside: avoid;
  break-inside: avoid;
}

.page-break-table {
  page-break-before: always;
  break-before: page;
}

.page-break-table table {
  page-break-inside: avoid;
  break-inside: avoid;
}

.maturityTabs .MuiTabScrollButton-root {
  display: none;
}
.tab-mat {
  padding: 10px 20px !important;
  background-color: #e8eaf6 !important;
  color: #1a237e !important;
  border: none !important;
  cursor: pointer !important;
  transition: background-color 0.3s ease !important;
  font-weight: bold !important;
  letter-spacing: 0.2px !important;
}
.tab-mat:hover {
  background-color: #c5cae9 !important;
}

.tab-mat.active {
  background-color: #3f51b5;
  color: #ffffff;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}
.maturityTabs button {
  max-width: fit-content;
  color: #5b6dab;
}
.maturityTabsContent {
  background-color: #f5f5f5;
  border-radius: 5px;
  border-left: 5px solid #3f51b5 !important;
  transition: background-color 0.3s ease !important;
}
.maturityTabsContent:hover {
  background-color: #eeeeee !important;
}
.tab-panel-mat {
  border-left: solid 4px #899ed4;
  background-color: #fdfdfd !important;
  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.2);
}
.maturityTabsContent p {
  font-size: 16px;
  font-weight: bold;
  color: #2a3c55 !important;
  text-align: center;
  margin-top: 5px;
}

.swith-mat .MuiSwitch-switchBase {
  color: #899ed4 !important;
}
.maturityTabsContent .MuiAccordionSummary-root.MuiAccordionSummary-gutters {
  border: solid 1px #d3e5ff;
}
.rs-picker-popup {
  z-index: 1333;
  /* html is zoomed to 0.8; inverse zoom keeps calendar clicks on the day cell. */
  zoom: 1.25;
}
.rs-picker-daterange-header {
  display: none;
}
.missionBox {
  background-color: #fff;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-width: 350px;
  /* font-family: 'Arial', sans-serif; */
  /* border-left: 4px solid; */
}

.missionBox-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  height: 70px;
}

.missionBox-header h3 {
  font-size: 17px;
  margin: 0;
  color: #333;
  line-height: 25px;
  text-transform: capitalize;
}

.missionBox-status {
  padding: 4px 10px;
  border-radius: 15px;
  font-size: 12px;
  color: #fff;
}

.missionBox-details p {
  margin: 8px 0;
  color: #666;
}

.missionBox-info p {
  justify-content: space-between;
  display: flex;
  font-size: 14px;
  margin: 0;
}

.missionBox-info p span {
  font-weight: bold;
  color: rgb(59 192 195);
}

.missionBox-members {
  display: flex;
  align-items: center;
  margin: 16px 0;
}

.missionBox-member-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  margin-right: 5px;
}

.missionBox-progress {
  margin-top: 10px;
}

.missionBox-progress-bar {
  height: 8px;
  background-color: #f0f0f0;
  border-radius: 5px;
  margin-top: 5px;
}

.missionBox-progress-bar-inner {
  height: 100%;
  border-radius: 5px;
}
.missionBox-container {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: start;
}

.missionBox-container > * {
}
* {
  font-family: 'Roboto', sans-serif !important;
}
.line-clamp-2 {
  /* from justify to start */
  text-align: start;
}
button {
  width: fit-content !important;
}
.dash-tabs button {
  /* text-transform: capitalize !important; */
}
.css-gke8zf-MuiButtonBase-root-MuiTab-root {
  text-transform: capitalize !important;
  height: fit-content !important;
}
.css-13h0qwj-MuiButtonBase-root-MuiTab-root {
  min-width: fit-content !important;
}
.breadcrumbs {
  height: fit-content !important;
}

.maturityTabs .css-heg063-MuiTabs-flexContainer {
  gap: 0 !important;
}
.maturityTabsContent .MuiBox-root {
  padding: 24px !important;
}
/* .MuiDataGrid-cell--withRenderer {
  display: flex;
  justify-content: center !important;
  margin: auto;
  text-align: center !important;
}
.MuiDataGrid-columnHeaderTitleContainerContent {
  margin: auto;
} */

a {
  color: rgb(19, 39, 67);
  font-weight: bold;
}
.MuiBox-root .css-9h98sf {
  height: 100vh;
}
.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.hover\\:bg-gray-300:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(209 213 219 / var(--tw-bg-opacity, 1));
}
.hover\\:text-\\[\\#132743\\]:hover {
  --tw-text-opacity: 1;
  color: rgb(19 39 67 / var(--tw-text-opacity, 1));
}
.hover\\:text-gray-800:hover {
  --tw-text-opacity: 1;
  color: rgb(31 41 55 / var(--tw-text-opacity, 1));
}
.hover\\:text-white:hover {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA;AAAoB;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AAApB;EAAA;IAAA;EAAoB;AAAA;AACpB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,yBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AACnB,6CAA6C;AAC7C;EACE,2BAA2B;EAC3B,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB,qBAAmB;EAAnB,0BAAmB;EAAnB,iBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;EACxB,kCAAkC;EAClC,cAAc;AAChB;AACA,iCAAiC;AACjC;EACE,wBAAwB;AAC1B;;AAEA,qDAAqD;AACrD;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,SAAS;AACX;;AAEA;6EAC6E;AAC7E;;EAEE,OAAO;AACT;;AAEA,uEAAuE;AACvE;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,oDAAoD;AACpD,8EAA8E;AAC9E;;EAEE,UAAU,EAAE,iCAAiC;AAC/C;;AAEA;;yEAEyE;AACzE;;EAEE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;;EAEE,OAAO;EACP,0BAA0B;AAC5B;AACA;;;;;;;GAOG;;AAEH;EACE,SAAS;EACT,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,oCAAoC;AACtC;;AAEA,6FAA6F;AAC7F;EACE,+BAA+B;AACjC;;AAEA,0EAA0E;AAC1E;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA,8FAA8F;AAC9F;EACE,qBAAqB;AACvB;AACA;;;;;;EAME,2CAA2C;AAC7C;AACA;EACE,2CAA2C;AAC7C;;AAEA;EACE;sEACoE;AACtE;;AAEA;EACE,uBAAuB;EACvB,iDAAiD;AACnD;AACA;EACE,uBAAuB;AACzB;AACA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;AACb;AACA;EACE,gBAAgB;AAClB;;AAEA,wEAAwE;AACxE;EACE,aAAa,EAAE,iCAAiC;AAClD;;AAEA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,+BAA+B;AACjC;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;AACf;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA,6EAA6E;AAC7E;EACE,UAAU,EAAE,iCAAiC;AAC/C;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;AACA;EACE,6BAA6B;EAC7B,oCAAoC;EACpC,yBAAyB;EACzB,uBAAuB;EACvB,0BAA0B;EAC1B,iDAAiD;EACjD,4BAA4B;EAC5B,gCAAgC;AAClC;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,wCAAwC;AAC1C;AACA;EACE,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,iDAAiD;AACnD;AACA;EACE,oCAAoC;AACtC;AACA;EACE,8BAA8B;EAC9B,oCAAoC;EACpC,yCAAyC;AAC3C;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,+EAA+E;EAC/E,UAAU;AACZ;AACA;EACE,aAAa;AACf;AACA;EACE,sBAAsB;EACtB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,sCAAsC;EACtC,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,8BAA8B;EAC9B,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,sBAAsB;AACxB;;AAEA;AACA;AACA;EACE,4CAA4C;AAC9C;AACA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2CAA2C;AAC7C;AACA;EACE,qCAAqC;EACrC,8BAA8B;AAChC;AACA;EACE,iCAAiC;AACnC;AACA;EACE,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,wBAAwB;AAC1B;AACA;;;;;;;;GAQG;;AAEH;EACE,sBAAsB;EACtB,iBAAiB;AACnB;AACA;EACE,aAAa;AACf;AAjZA;EAAA,kBAkZA;EAlZA,kBAkZA;EAlZA;AAkZA;AAlZA;EAAA,kBAkZA;EAlZA;AAkZA;AAlZA;EAAA,oBAkZA;EAlZA;AAkZA;AAlZA;EAAA,oBAkZA;EAlZA;AAkZA;AAlZA;EAAA,oBAkZA;EAlZA;AAkZA","sourcesContent":["@tailwind components;\n@tailwind utilities;\n/* Apply line-clamp-2 to all DataGrid cells */\n.css-1n4ipc8-MuiDataGrid-root .MuiDataGrid-cell {\n  /* color: red !important; */\n  @apply line-clamp-2;\n}\n\n.page-break-avoid {\n  break-inside: avoid;\n  page-break-inside: avoid;\n  -webkit-column-break-inside: avoid;\n  display: block;\n}\n/* Hide sorting arrows globally */\n.MuiDataGrid-sortIcon {\n  display: none !important;\n}\n\n/* Fix header title alignment after removing arrows */\n.MuiDataGrid-columnHeaderTitleContainer {\n  flex-direction: row !important;\n}\n\nhtml {\n  background-color: #eff3f4;\n  zoom: 0.8;\n}\n\n/* Full-bleed get-started / control-plane shells — cancel global zoom so\n   fixed inset:0 and 100% height actually cover the viewport (no gray gap). */\nhtml.gs-no-zoom,\nhtml.auth-no-zoom {\n  zoom: 1;\n}\n\n/* Workspace setup: keep the 80% zoom, but paint the letterbox white. */\nhtml.sn-canvas {\n  background-color: #fff;\n}\n\nbody {\n  margin: 0;\n  background-color: #eff3f4;\n  min-height: 100%;\n}\n\n#root {\n  min-height: 100%;\n  background-color: #eff3f4;\n}\n\n/* Fix MUI Popover/Menu positioning with zoom: 0.8 */\n/* When html is zoomed to 80%, fixed-position dropdowns need inverse scaling */\n.MuiPopover-root,\n.MuiMenu-root {\n  zoom: 1.25; /* Inverse of 0.8: 1/0.8 = 1.25 */\n}\n\n/* Fix Joyride positioning/coverage with global html zoom: 0.8.\n   Overlay AND floater must use the same inverse zoom, otherwise the\n   spotlight tracks the target while the tooltip stays near the origin. */\n.react-joyride__overlay,\n.react-joyride__floater {\n  zoom: 1.25;\n  transform-origin: top left;\n}\n\n.react-joyride__tooltip,\n.react-joyride__beacon {\n  zoom: 1;\n  transform-origin: top left;\n}\n/* .MuiBox-root.css-9h98sf {\n  height: 115vh !important;\n  width: 100% !important;\n}\n\n.MuiBox-root.css-9h98sf > * {\n  width: auto !important;\n} */\n\nbody {\n  margin: 0;\n  overflow-x: hidden;\n  background-color: #fbfbfb;\n  width: 100%;\n  min-height: 100vh;\n}\n\n#root {\n  min-height: 100vh;\n  width: 100%;\n  background-color: #fbfbfb;\n}\nbody *::first-letter {\n  text-transform: uppercase !important;\n}\n\n/* MUI Dialog: global ::first-letter + zoom on .MuiModal-root can hide or distort list text */\n.MuiDialog-root *::first-letter {\n  text-transform: none !important;\n}\n\n/* Import wizard dialog must sit above DataGrid loading skeleton overlay */\n.import-risks-wizard-dialog.MuiDialog-root {\n  z-index: 10000 !important;\n  zoom: 1 !important;\n}\n\n.import-risks-wizard-dialog .MuiDialog-container,\n.import-risks-wizard-dialog .MuiDialog-paper {\n  pointer-events: auto !important;\n}\n\n/* Keep grid loading overlay inside the grid stacking context so it cannot paint over modals */\n.MuiDataGrid-root .MuiDataGrid-overlayWrapper {\n  z-index: 1 !important;\n}\nh3,\nh1,\nh2,\nh4,\nh5,\nh6 {\n  /* text-transform: capitalize !important; */\n}\n.title {\n  /* text-transform: capitalize !important; */\n}\n\ncode {\n  font-family:\n    source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n.rs-input-group {\n  height: 100% !important;\n  border: 0.8px solid rgba(0, 0, 0, 0.2) !important;\n}\n.rs-input-group-lg.rs-input-group > .rs-input {\n  height: auto !important;\n}\n.rs-input-group-lg.rs-input-group > .rs-input-group-addon {\n  height: auto !important;\n}\n\n.scheduler_default_main {\n  width: 100%;\n}\n.scheduler_default_corner {\n  z-index: -999999;\n}\n\n/* Si vous souhaitez également cacher la barre de défilement verticale */\n::-webkit-scrollbar {\n  display: none; /* Cache la barre de défilement */\n}\n\n.breadcrumbs .title {\n  margin-left: 0px;\n}\n.breadcrumbs div {\n  margin-left: 0px;\n}\n\n.breadcrumbs button {\n  padding: 8px 48px;\n}\n.App {\n  background-color: #fbfbfb;\n}\n.MuiSvgIcon-fontSizeSmall {\n  color: rgba(255, 255, 255, 0.5);\n}\n\na:hover,\n*:focus {\n  text-decoration: none;\n  outline: none;\n}\n.dash-tabs button {\n  color: #5b6b87;\n  font-size: 16.875px;\n  letter-spacing: 0;\n}\n\n/* Fix for MUI Tabs indicator misalignment when global zoom: 0.8 is applied */\n.MuiTabs-indicator {\n  zoom: 1.25; /* Inverse of 0.8: 1/0.8 = 1.25 */\n}\n\n.pdf-page-group {\n  page-break-inside: avoid;\n  break-inside: avoid;\n}\n\n.page-break-table {\n  page-break-before: always;\n  break-before: page;\n}\n\n.page-break-table table {\n  page-break-inside: avoid;\n  break-inside: avoid;\n}\n\n.maturityTabs .MuiTabScrollButton-root {\n  display: none;\n}\n.tab-mat {\n  padding: 10px 20px !important;\n  background-color: #e8eaf6 !important;\n  color: #1a237e !important;\n  border: none !important;\n  cursor: pointer !important;\n  transition: background-color 0.3s ease !important;\n  font-weight: bold !important;\n  letter-spacing: 0.2px !important;\n}\n.tab-mat:hover {\n  background-color: #c5cae9 !important;\n}\n\n.tab-mat.active {\n  background-color: #3f51b5;\n  color: #ffffff;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n}\n.maturityTabs button {\n  max-width: fit-content;\n  color: #5b6dab;\n}\n.maturityTabsContent {\n  background-color: #f5f5f5;\n  border-radius: 5px;\n  border-left: 5px solid #3f51b5 !important;\n  transition: background-color 0.3s ease !important;\n}\n.maturityTabsContent:hover {\n  background-color: #eeeeee !important;\n}\n.tab-panel-mat {\n  border-left: solid 4px #899ed4;\n  background-color: #fdfdfd !important;\n  box-shadow: 0 3px 15px rgba(0, 0, 0, 0.2);\n}\n.maturityTabsContent p {\n  font-size: 16px;\n  font-weight: bold;\n  color: #2a3c55 !important;\n  text-align: center;\n  margin-top: 5px;\n}\n\n.swith-mat .MuiSwitch-switchBase {\n  color: #899ed4 !important;\n}\n.maturityTabsContent .MuiAccordionSummary-root.MuiAccordionSummary-gutters {\n  border: solid 1px #d3e5ff;\n}\n.rs-picker-popup {\n  z-index: 1333;\n  /* html is zoomed to 0.8; inverse zoom keeps calendar clicks on the day cell. */\n  zoom: 1.25;\n}\n.rs-picker-daterange-header {\n  display: none;\n}\n.missionBox {\n  background-color: #fff;\n  padding: 16px;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  max-width: 350px;\n  /* font-family: 'Arial', sans-serif; */\n  /* border-left: 4px solid; */\n}\n\n.missionBox-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  height: 70px;\n}\n\n.missionBox-header h3 {\n  font-size: 17px;\n  margin: 0;\n  color: #333;\n  line-height: 25px;\n  text-transform: capitalize;\n}\n\n.missionBox-status {\n  padding: 4px 10px;\n  border-radius: 15px;\n  font-size: 12px;\n  color: #fff;\n}\n\n.missionBox-details p {\n  margin: 8px 0;\n  color: #666;\n}\n\n.missionBox-info p {\n  justify-content: space-between;\n  display: flex;\n  font-size: 14px;\n  margin: 0;\n}\n\n.missionBox-info p span {\n  font-weight: bold;\n  color: rgb(59 192 195);\n}\n\n.missionBox-members {\n  display: flex;\n  align-items: center;\n  margin: 16px 0;\n}\n\n.missionBox-member-avatar {\n  width: 30px;\n  height: 30px;\n  border-radius: 50%;\n  margin-right: 5px;\n}\n\n.missionBox-progress {\n  margin-top: 10px;\n}\n\n.missionBox-progress-bar {\n  height: 8px;\n  background-color: #f0f0f0;\n  border-radius: 5px;\n  margin-top: 5px;\n}\n\n.missionBox-progress-bar-inner {\n  height: 100%;\n  border-radius: 5px;\n}\n.missionBox-container {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  justify-content: start;\n}\n\n.missionBox-container > * {\n}\n* {\n  font-family: 'Roboto', sans-serif !important;\n}\n.line-clamp-2 {\n  /* from justify to start */\n  text-align: start;\n}\nbutton {\n  width: fit-content !important;\n}\n.dash-tabs button {\n  /* text-transform: capitalize !important; */\n}\n.css-gke8zf-MuiButtonBase-root-MuiTab-root {\n  text-transform: capitalize !important;\n  height: fit-content !important;\n}\n.css-13h0qwj-MuiButtonBase-root-MuiTab-root {\n  min-width: fit-content !important;\n}\n.breadcrumbs {\n  height: fit-content !important;\n}\n\n.maturityTabs .css-heg063-MuiTabs-flexContainer {\n  gap: 0 !important;\n}\n.maturityTabsContent .MuiBox-root {\n  padding: 24px !important;\n}\n/* .MuiDataGrid-cell--withRenderer {\n  display: flex;\n  justify-content: center !important;\n  margin: auto;\n  text-align: center !important;\n}\n.MuiDataGrid-columnHeaderTitleContainerContent {\n  margin: auto;\n} */\n\na {\n  color: rgb(19, 39, 67);\n  font-weight: bold;\n}\n.MuiBox-root .css-9h98sf {\n  height: 100vh;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
